module.exports = __webpack_public_path__ + "img/poland-flag.33c43937.svg";